export enum CatalogActionType {
  FETCH_CATEGORIES = 'FETCH_CATEGORIES',
  FETCH_PRODUCTS = 'FETCH_PRODUCTS',
  FETCH_SPECIAL_OFFERS = 'FETCH_SPECIAL_OFFERS',
  FETCH_QUICK_ORDERS = 'FETCH_QUICK_ORDERS',
  FETCH_FAVORITES = 'FETCH_FAVORITES',
  FETCH_RECOMMENDED_PRODUCTS = 'FETCH_RECOMMENDED_PRODUCTS',
  FETCH_RECOMMENDED_LIST = 'FETCH_RECOMMENDED_LIST',
  FETCH_PRODUCT = 'FETCH_PRODUCT',
  FETCH_WISHLIST = 'FETCH_WISHLIST',
  FETCH_ADD_TO_WISHLIST = 'FETCH_ADD_TO_WISHLIST',
  FETCH_REMOVE_FROM_WISHLIST = 'FETCH_REMOVE_FROM_WISHLIST',
  FETCH_ALIGNMENT = 'FETCH_ALIGNMENT',
  FETCH_ADD_TO_CART = 'FETCH_ADD_TO_CART',
  FETCH_SHIP_TO = 'FETCH_SHIP_TO',
  FETCH_PRODUCTS_AGGREGATIONS = 'FETCH_PRODUCTS_AGGREGATIONS',
  FETCH_PRODUCT_WISHLIST = 'FETCH_PRODUCT_WISHLIST',
  FETCH_ADD_TO_FULL_ORDER = 'FETCH_ADD_TO_FULL_ORDER',
  FETCH_SHIP_TO_METHOD = 'FETCH_SHIP_TO_METHOD',
  FETCH_PAYMENT_METHOD = 'FETCH_PAYMENT_METHOD',
  FETCH_LOW_STOCK_PRODUCTS = 'FETCH_LOW_STOCK_PRODUCTS',
  FETCH_FREEBEER_ID = 'FETCH_FREEBEER_ID',
  FETCH_FREEBEER_PRODUCT = 'FETCH_FREEBEER_PRODUCT',
  FETCH_ADD_FREE_BEER_PRODUCT= 'FETCH_ADD_FREE_BEER_PRODUCT',
  FETCH_REMOVE_FREE_BEER_PRODUCT= 'FETCH_REMOVE_FREE_BEER_PRODUCT',
  FETCH_ADD_COMPLET_LAYER = 'FETCH_ADD_COMPLET_LAYER',
  FETCH_SHIP_TO_ADDRESS = 'FETCH_SHIP_TO_ADDRESS',
  FETCH_FREEBEERS_INFO = 'FETCH_FREEBEERS_INFO',
  FETCH_REMOVE_MULTIPLE_FREE_BEER_PRODUCT = 'FETCH_REMOVE_MULTIPLE_FREE_BEER_PRODUCT'

}
